<div class="grid">
  <div class="col-12 mb-2">
    <div class="card title-card">
      <div class="flex justify-content-between" role="toolbar">
        <div class="flex">
          <div>
            <i class="pi pi-users title-card-icon"></i>
          </div>
          <div>
            <p class="mb-0 text-3xl title">{{'misc.userGroups' | transloco}}</p>
            <p>
              {{'misc.userGroupsDescription' | transloco | capitalize}}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="card">
      <ng-container *ngIf="!isUserGroupLoading && userForm">
        <form *ngIf="userForm" [formGroup]="userForm">
          <div class="grid">
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="username">{{'attribute.username' | transloco}}: </label>
              </div>
              <div class="col-12">
                <input class="w-full" formControlName="username" id="username" pInputText type="text">
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="email">{{'attribute.email' | transloco}}:</label>
              </div>
              <div class="col-12">
                <input class="w-full" formControlName="email" id="email" pInputText type="text">
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="organization">{{'model.organization' | transloco}}: </label>
              </div>
              <div class="col-12">
                <input class="w-full" formControlName="organization" id="organization" pInputText type="text">
              </div>
            </div>
          </div>
        </form>
        <div *ngIf="loadedData" class="col-12 md:col-12">
          <p-pickList [source]="availableGroups" sourceHeader="{{ 'attribute.availableGroups' | transloco }}:"
            [target]="targetGroups" targetHeader="{{ 'attribute.selectedGroups' | transloco }}:" [responsive]="true"
            filterBy="name" dragdrop="true" sourceFilterPlaceholder="{{ 'filter.name' | transloco }}"
            targetFilterPlaceholder="{{ 'filter.name' | transloco }}" [sourceStyle]="{'height':'300px'}"
            [targetStyle]="{'height':'300px'}" [showSourceControls]="false" [showTargetControls]="false">
            <ng-template let-group pTemplate="item">
              <div class="pick-list-item">
                <div class="image-container">
                  <div class="flex flex-column">
                    <label [style.background-color]="group.color" readonly class="theme-picker color-group">
                      <input [(ngModel)]="group.color" disabled type="color">
                    </label>
                  </div>
                </div>
                <div class="pick-list-detail">
                  <div class="mb-2 title-item-pick-list">{{group.name}}</div>
                  <span>{{group.description}}</span>
                </div>
                <div class="pick-list-attribute mt-4">
                  <div class="flex align-items-center justify-content-center">
                    <i class="pi pi-wifi icon-pick-list"></i>
                    {{group.totalMachines}} {{ 'attribute.machines' | transloco }}
                  </div>
                </div>
              </div>
            </ng-template>
          </p-pickList>
        </div>
        <div class="grid">
          <div class="col-12">
            <div class="mt-auto col-12">
              <div class="flex justify-content-between mt-4">
                <button [label]="'common.cancel' | transloco" [routerLink]="'/users'" pButton class="p-button-danger"
                  iconPos="right"></button>
                <p-button [label]="'common.save' | transloco" [loading]="persistingChanges"
                  (onClick)="persistUserGroupsData()" styleClass="p-button-primary"></p-button>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="isUserGroupLoading || userForm == null">
        <div>
          <div class="grid">
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="username">{{'attribute.username' | transloco}}: </label>
              </div>
              <div class="col-12">
                <p-skeleton width="100%" height="2.5rem"></p-skeleton>
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="email">{{'attribute.email' | transloco}}:</label>
              </div>
              <div class="col-12">
                <p-skeleton width="100%" height="2.5rem"></p-skeleton>
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="organization">{{'model.organization' | transloco}}: </label>
              </div>
              <div class="col-12">
                <p-skeleton width="100%" height="2.5rem"></p-skeleton>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 md:col-12 flex mt-4">
          <div style="width: 46%;">
            <div class="form-field mb-2">
              <label>{{ 'attribute.availableGroups' | transloco }}:</label>
            </div>
            <p-skeleton width="100%" height="25rem"></p-skeleton>
          </div>
          <div style="width: 8%;">
            <div class="w-4rem m-8 ml-auto mr-auto">
              <div class="mb-2">
                <p-skeleton width="4rem" height="2.5rem"></p-skeleton>
              </div>
              <div class="mb-2">
                <p-skeleton width="4rem" height="2.5rem"></p-skeleton>
              </div>
              <div class="mb-2">
                <p-skeleton width="4rem" height="2.5rem"></p-skeleton>
              </div>
              <div class="mb-2">
                <p-skeleton width="4rem" height="2.5rem"></p-skeleton>
              </div>
            </div>
          </div>
          <div style="width: 46%;">
            <div class="form-field mb-2">
              <label>{{ 'attribute.selectedGroups' | transloco }}:</label>
            </div>
            <p-skeleton width="100%" height="25rem"></p-skeleton>
          </div>
        </div>
        <div class="grid">
          <div class="col-12">
            <div class="mt-auto col-12">
              <div class="flex justify-content-between mt-4">
                <div class="w-7rem">
                  <p-skeleton heigth="2.5rem"></p-skeleton>
                </div>
                <div class="w-7rem">
                  <p-skeleton heigth="2.5rem"></p-skeleton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
